import { compose, withHandlers, withState, withPropsOnChange } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import PhoneInputComponent from '../components/PhoneInputComponent';
import { sendAppLinkSms } from '../../../mobileApp/actions';
import { getExtension } from '../../../extensions';

const PhoneInputComponentContainer = compose(
  withRouter,
  connect((state, ownProps) => ({
    extension: getExtension(state, ownProps.params.brandRoute),
    sendAppLinkSms,
  })),
  withState('phone', 'setPhone', null),
  withState('brandId', 'setBrandId', null),
  withState('smsStatus', 'setSmsStatus', ''),
  withState('isFetching', 'setIsFetching', false),
  withHandlers({
    send: props => async () => {
      props.setIsFetching(true);
      props.setSmsStatus('');
      const res = await props.sendAppLinkSms(props.brandId, props.phone);
      if (!res.ok) {
        props.setSmsStatus('error');
      } else {
        props.setSmsStatus('success');
      }
      props.setIsFetching(false);
    },
    changePhoneNumber: props => (phone) => {
      props.setSmsStatus('');
      props.setPhone(`+${phone}`);
    },
  }),
  withPropsOnChange(['extension'], async (props) => {
    props.setBrandId(props.extension.brandId);
  }),
);

export default PhoneInputComponentContainer(PhoneInputComponent);



// WEBPACK FOOTER //
// ./src/app/notifications/shared/containers/PhoneInputComponent.js